<template>
  <b-row class="onboarding-intro-video">
    <b-col cols="12" md="10" offset-md="1">
      <b-card class="shadow mx-md-10 px-1 px-md-10 py-2">

        <div class="my-3 d-flex flex-column justify-content-center align-items-center" v-if="!$root.isCXR">
          <i18n path="onboarding.introduction-video.title" tag="h2" class="text-center">
            <template v-slot:fullName><strong>{{ user.fullName }}</strong></template>
          </i18n>
          <!-- eslint-disable-next-line vue-i18n/no-missing-keys -->
          <i18n v-if="$te('onboarding.introduction-video.description')" path="onboarding.introduction-video.description"
            tag="p" class="my-3 text-center welcome-description">
              <template v-slot:fullName><strong>{{ user.fullName }}</strong></template>
          </i18n>
        </div>

        <div class="p-1" v-if="$root.isCXR">
          <div class="embed-responsive embed-responsive-16by9">
            <iframe class="embed-responsive-item" frameborder="0" src="https://player.vimeo.com/video/806595288?h=976fca6404"></iframe>
          </div>
        </div>
        <div class="p-1" v-else>
          <video-player class="mb-3 ml-3 mr-3 onboarding-video" :options="videoOptions" height="65vh"/>
        </div>

        <b-row class="px-5">
          <b-col class="d-flex justify-content-end align-items-center px-4">
            <b-button @click.prevent="$emit('goNext')" class="px-5" variant="primary">
              {{ $t('ctas.continue') }}
            </b-button>
          </b-col>
        </b-row>
      </b-card>

      <cxr-partner-logos v-if="$root.isCXR" class="my-5"/>
    </b-col>
  </b-row>
</template>

<script>
import { mapRoot } from '@src/mixins/root';
import VideoPlayer from '@/components/misc/video-player';
import CxrPartnerLogos from '@/components/success/cxr-partner-logos';

export default {
  name: 'OnboardingIntroVideo',
  components: {
    VideoPlayer,
    CxrPartnerLogos,
  },
  computed: {
    ...mapRoot([ 'company', 'user' ]),
    videoOptions() {
      const { sitePreferences: { onboardingIntroVideoUrl } = {} } = this.company || {};

      const options = {
        autoplay: false,
        preload: 'auto',
        controls: true,
        sources: [],
      };

      if (this.$root.isCommunitySite) {
        options.sources.push({
          type: 'video/mp4',
          src: 'https://real-links-assets.s3.eu-west-2.amazonaws.com/csr-hr-8Kw3K/2020-03-24/8b97ad41-0378-46b4-b4ac-ab477b2dcaa7/CommunityIntro.mp4',
        });
      } else if (onboardingIntroVideoUrl) {
        options.sources.push({
          type: 'video/mp4',
          src: onboardingIntroVideoUrl,
        });
      } else if (this.company && this.company.sitePreferences && this.company.sitePreferences.useGamification) {
        options.sources.push({
          type: 'video/mp4',
          src: 'https://real-links-assets.s3.eu-west-2.amazonaws.com/site-assets/video/employeeintro-gamification.mp4',
        });
      } else {
        options.sources.push({
          type: 'video/mp4',
          src: 'https://real-links-assets.s3.eu-west-2.amazonaws.com/site-assets/video/employeeintro.mp4',
        });
      }

      if (this.company && this.company.siteBranding && this.company.siteBranding.bigLogo) {
        options.poster = this.company.siteBranding.bigLogo.fileLocation;
      }
      return options;
    },
  },
};
</script>

<style lang="scss" scoped>
.onboarding-intro-video {
  .onboarding-video {
    width: 100%;
  }
  .welcome-description {
    max-width: 660px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/onboarding/Video.vue